import { useContext } from "react";
import ContadoresContext from "../Context/ContadoresContext";
export function useContadores() {
    const contadoresHelpers = useContext(ContadoresContext);
    return contadoresHelpers;
}